import { Component, Input } from '@angular/core';
import { cardContentStyles, CardContentProps } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-card-content',
  template: `
    <div [ngClass]="cardContent">
      <kite-stack 
        [align]="align"
        [direction]="direction"
        [spacing]="spacing"
        [justify]="justify"
      >
        <ng-content></ng-content>
      </kite-stack>
    </div>
  `,
})

export class CardContentComponent {
  /**
   * Css del componente
   */
   @Input() css: CardContentProps['css'];
   /**
    * Alineación de flexbox
    */
   @Input() align: CardContentProps['align'];
   /**
    * Dirección de flexbox
    */
   @Input() direction: CardContentProps['direction'] = 'column';
   /**
    * Espaciado entre componentes
    */
   @Input() spacing: CardContentProps['spacing'];
 
   /**
    * Justify entre componentes
    */
   @Input() justify: CardContentProps['justify'];

  public get cardContent(): string[] {
    return [
      cardContentStyles({ css: this.css }).className,
    ];
  }
}